'use client'

import PropTypes from 'prop-types'
import { PhoneTypeSelect } from '@repo/ui/PhoneTypeSelect'
import { TextEntry } from '@repo/ui/TextEntry'
import MUICheckbox from '@mui/material/Checkbox'
import MUIFormControlLabel from '@mui/material/FormControlLabel'
import MUIStack from '@mui/material/Stack'
import { useState, useEffect } from 'react'
import MUIIconButton from '@mui/material/IconButton'
import { CrossIcon } from '@repo/ui/CrossIcon'
import { useTheme } from '@mui/material/styles'
// import { useLookupsStore } from '@repo/store/useLookupsStore'

export const PhoneNumberRow = ({
  defaultDescription,
  //defaultPhoneType,
  defaultPhoneNumber,
  defaultIsMainNumber,
  index = 0,
  id = new Date().getTime(),
  onChange = (newValue) => {
    console.log(newValue)
  },
  onRemove: onRemove = () => {},
  validationErrors,
  testData = null
}) => {
  // const { phoneTypes } = useLookupsStore()
  const [description, setDescription] = useState(defaultDescription || '')
  const [phoneType, setPhoneType] = useState(null)
  const [phoneNumber, setPhoneNumber] = useState(defaultPhoneNumber || '')
  const [isMainNumber, setIsMainNumber] = useState(defaultIsMainNumber || false)
  const theme = useTheme()

  useEffect(() => {
    if (onChange) onChange({ description, phoneType, phoneNumber, isMainNumber, index, id })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [description, phoneType, phoneNumber, isMainNumber])

  useEffect(() => {
    setIsMainNumber(defaultIsMainNumber)
  }, [defaultIsMainNumber])

  return (
    <MUIStack
      data-testid="PhoneNumberRow"
      direction="row"
      alignItems="center"
      justifyContent="flex-start"
      gap={4}
      sx={{ mt: 8, mb: 2, width: '100%', backgroundColor: 'white', padding: '24px', borderRadius: '4px' }}
    >
      <MUIStack
        direction="row"
        alignItems="center"
        justifyContent="flex-start"
        gap={4}
        flexWrap="wrap"
        sx={{
          width: 'calc(100% - 56px)'
        }}
      >
        <TextEntry
          size="medium"
          value={phoneNumber}
          onChange={setPhoneNumber}
          label="Phone number"
          limit={30}
          sx={{ width: '100%', maxWidth: '450px' }}
          adornment="#"
          required
          autoFocus
          errors={validationErrors}
          name={`clientPhones[${index}].phoneNumber`}
        />

        <PhoneTypeSelect
          value={phoneType}
          onChange={setPhoneType}
          size="medium"
          sx={{ width: '100%', maxWidth: '450px' }}
          errors={validationErrors}
          name={`clientPhones[${index}].phoneType`}
          required
          testData={testData}
        />

        <TextEntry
          size="medium"
          value={description}
          onChange={setDescription}
          label="Description"
          limit={30}
          sx={{ width: '100%', maxWidth: '450px' }}
          errors={validationErrors}
          name={`clientPhones[${index}].description`}
          required
        />

        <MUIFormControlLabel
          sx={{ mr: 0, width: '100%', maxWidth: '450px' }}
          control={<MUICheckbox checked={isMainNumber} onChange={(e) => setIsMainNumber(e.target.checked)} />}
          label="This is the main number for this client"
        />
      </MUIStack>

      <MUIIconButton onClick={() => onRemove(index)} title="Remove phone number">
        <CrossIcon sx={{ color: theme?.palette?.text?.secondary || 'black', width: '24px', height: '24px' }} />
      </MUIIconButton>
    </MUIStack>
  )
}

PhoneNumberRow.propTypes = {
  defaultDescription: PropTypes.string,
  defaultPhoneType: PropTypes.object,
  defaultPhoneNumber: PropTypes.string,
  defaultIsMainNumber: PropTypes.bool,
  id: PropTypes.number,
  index: PropTypes.number,
  onChange: PropTypes.func,
  onRemove: PropTypes.func,
  validationErrors: PropTypes.object,
  testData: PropTypes.array
}
